import a = require("../core/array.helper");
import uiCore = require("../core/uicore");
import { Component, Input } from "@angular/core";

import * as dataCore from "../core/datacore";

export class MultiSelectDirective implements uiCore.IDirective {

    private arrayHelper: a.ArrayHelper;

    constructor(...args: any[]) {
        var locator = uiCore.DependencyLocator.Create(MultiSelectDirective, args);

        this.arrayHelper = locator.getDependencyById(a.ArrayHelper.Id);
    }

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "multiselect",
        Template: require("./multiselect.html"),
        AngularDependencies: [uiCore.ScopeDependency, { $angularInjectionId: a.ArrayHelper.Id }],
        Bindings: {
            label: "@",
            height: "@",
            availableItems: "=",
            selectedItems: "="
        }
    };

    public availableItems: any[];

    public selectedItems: any[];

    public selectedAvailableItems = [];

    public selectedPickedItems = [];

    public addSelectedItems() {
        this.arrayHelper.addItems(this.selectedAvailableItems, this.selectedItems);
        this.selectedAvailableItems = [];
    }

    public removeSelectedItems() {
        this.arrayHelper.removeItems(this.selectedPickedItems, this.selectedItems);
        this.selectedPickedItems = [];
    }
}

type MultiSelectEntity = Nema.Crew.Model.NameSortTagId;

@Component({
    selector: "crew-multiselect",
    template: require('./multiselect.component.html')
})
export class MultiselectComponent {

    constructor(private arrayHelper: a.ArrayHelper) {
        this.marginTopPx = 0;
    }

    @Input()
    label: string;

    @Input()
    height: string;

    @Input()
    marginTopPx: number;

    @Input()
    availableItems: MultiSelectEntity[];

    @Input()
    selectedItems: MultiSelectEntity[];

    markedAvailableItems: MultiSelectEntity[] = [];
    markedSelectedItems: MultiSelectEntity[] = [];

    addMarkedItems(): void {
        this.addItems(this.markedAvailableItems);
    }

    addAllItems(): void {
        this.addItems(dataCore.orderBySortTagThenName(this.remainingAvailableItems));
    }

    addItemsById(ids: number[]): void {
        const itemsToAdd = ids.map(id => this.getAvailableItem(id)).filter(item => !!item);
        this.addItems(itemsToAdd);
    }

    removeMarkedItems(): void {
        this.removeItems(this.markedSelectedItems);
    }

    removeAllItems(): void {
        this.removeItems(this.selectedItems);
    }

    get remainingAvailableItems(): MultiSelectEntity[] {
        if (!this.availableItems) {
            return [];
        }

        return this.availableItems.filter(item => !this.selectedItems.some(selectedItem => selectedItem.Id === item.Id));
    }

    private addItems(items: MultiSelectEntity[]): void {
        this.arrayHelper.addItems(items, this.selectedItems);
        this.markedAvailableItems = [];
    }

    private removeItems(items: MultiSelectEntity[]): void {
        this.arrayHelper.removeItems(items, this.selectedItems);
        this.markedSelectedItems = [];
    }

    private getAvailableItem(id: number): MultiSelectEntity {
        return this.remainingAvailableItems.find(availableItem => availableItem.Id === id);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/multiselect.ts